import React, {Component, Fragment} from 'react';
import {observer} from "mobx-react";

import './App.scss';
import ScrollContent from "./components/ScrollContent";
import Nav from "./components/Nav";

class App extends Component {

    componentDidMount() {

    }

    componentDidUpdate() {
    }

    render() {
        const {store, aggregateMode} = this.props;

        return (
            <div className="App">
                {/*<Nav store={store}/>*/}
                <ScrollContent store={store} count={8} scrollProgress={store.scrollProgress}/>

            </div>
        );
    }

}

export default observer(App);
